<template>

    <div class="website::admin-websitePages-createEdit-moduleEditor-Gallery divide-y divide-gray-200">

        <Toolbar
            title="Module kiezen"
            instruction="Kies en configueer een module voor deze pagina."
        />

        <div class="flex px-5 py-10 sm:px-10">

            <div class="w-1/3 pr-0 selector bg-white rounded-md -space-y-px">

                <a v-for="(moduleData, moduleId, key) in modulesData"
                   href="#"
                   class="items-center relative border p-4 flex border-gray-200"
                   :class="{ active: moduleId === currentModuleId, 'rounded-t-md': key === 0, 'rounded-b-md': key === Object.keys(modulesData).length - 1 }"
                   @click="onModuleClick($event, moduleId)">

                    <div class="grid grid-cols-10 w-full">

                        <div class="flex items-center justify-center col-span-1">
                            <i class="text-2xl"
                               :class="moduleData.meta.icon">
                            </i>
                        </div>

                        <div class="mx-4 col-span-8">
                            <h5 class="block text-base font-medium text-gray-900">{{ moduleData.meta.name }}</h5>
                            <span class="block text-sm text-gray-500">{{ moduleData.meta.intro }}</span>
                        </div>

                        <i class="far fa-chevron-right flex items-center justify-center col-span-1"></i>

                    </div>

                </a>

            </div>

            <div class="w-2/3 pl-10">

                <div v-if="!currentModule" class="py-5 my-5 mx-auto flex items-center justify-center text-gray-400">

                    <i class="fal fa-hand-point-left mr-2 text-2xl"></i>
                    <span>Kies links een module.</span>

                </div>

                <div v-else class="w-full h-full flex flex-col px-4 py-5 overflow-auto">

                    <h2 class="text-2xl font-bold text-gray-900">{{ currentModule.meta.name }}</h2>
                    <div class="text-gray-700 text-md" v-html="currentModule.meta.description"></div>

                    <div class="row mt-5 mt-auto">

                        <div class="text-center text-muted col-9" v-if="!websitePage">
                            <i class="fa fa-exclamation-triangle mr-2"></i>
                            <span>
                                De pagina dient eerst aangemaakt te zijn alvorens content toegevoegd kan worden.<br/>
                                Klik bovenaan op "Opslaan" om hier verder te kunnen.
                            </span>
                        </div>

                        <div class="text-right" :class="!websitePage ? 'col-3' : 'col-12'">
                            <button class="btn btn-success ml-auto" @click="addCurrentModule"
                                    :disabled="!websitePage">
                                Kies deze module
                                <i class="far fa-arrow-right ml-2"></i>
                            </button>
                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>

</template>

<script>

import Toolbar from './Toolbar';

export default {

    components: {
        Toolbar,
    },

    props: {
        websitePage: Object,
        modulesData: Object,
    },

    data() {
        return {
            currentModuleId: null,
        };
    },

    mounted() {
    },

    methods: {

        onModuleClick($event, moduleId) {
            // Set
            this.currentModuleId = moduleId;

            // Avoid browser navigating.
            event.preventDefault();

            return false;
        },

        addCurrentModule() {
            this.$emit('moduleChoosed', this.currentModuleId);
        }
    },

    computed: {

        currentModule() {
            return this.modulesData[this.currentModuleId];
        }

    }

}

</script>

<style lang="scss" scoped>

.website\:\:admin-websitePages-createEdit-moduleEditor-Gallery {

    .selector {
        a.active {
            @apply bg-indigo-50 border-indigo-200 z-10;

            h5 {
                @apply text-indigo-900;
            }

            span {
                @apply text-indigo-700;
            }
        }
    }
}

</style>
